import { toast } from 'react-toastify';

import { CHAIN_BY_ID } from 'consts';
import { store } from 'store';
import { handleWeb3Error } from 'utils/helpers/handleError';
import { Chain } from 'viem';
import { useAccount, useSwitchChain as useWagmiSwitchChain } from 'wagmi';

const setRequestExpiredTimer = () => {
  return setTimeout(() => {
    const { requestingChainId, setRequestingChainId } = store.commonStore;
    if (!requestingChainId) return;
    toast.warning(
      'Perhaps an error occurred when switching network. Please try manually switching chain in your wallet, or reload the page and reconnect wallet.',
      { autoClose: false }
    );
    setRequestingChainId(null);
  }, 20_000);
};

export const useSwitchChain = () => {
  const { account, setChainId } = store.web3Store;
  const { requestingChainId, setRequestingChainId } = store.commonStore;
  const { switchChainAsync } = useWagmiSwitchChain();
  const { chainId: walletChainId } = useAccount();

  const switchChain = async (chainId: number) => {
    if (!account || chainId === walletChainId) {
      setChainId(chainId);
      return true;
    }

    const chain = CHAIN_BY_ID[chainId] as Chain | undefined;

    if (requestingChainId) {
      toast.warn(
        `You are already switching to ${chain?.name || `${chainId} chainId`}. Please check your wallet.`,
        {
          autoClose: false,
        }
      );
      return;
    }

    setRequestingChainId(chainId);
    const timerId = setRequestExpiredTimer();
    let isSuccess = false;

    try {
      await switchChainAsync({ chainId });
      console.log('switched to chain', chain?.name, chainId);
      isSuccess = true;
    } catch (err) {
      handleWeb3Error({
        err,
        source: 'switch chain',
      });
    } finally {
      clearTimeout(timerId);
      setRequestingChainId(null);
    }

    return isSuccess;
  };

  return { switchChain };
};
